"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _a;
"use strict";
const React = require("react");
const PropTypes = require("prop-types");
const xstate_1 = require("xstate");
const interpreter_1 = require("xstate/lib/interpreter");
const graph_1 = require("xstate/lib/graph");
const utils_1 = require("xstate/lib/utils");
const toRegex = require("path-to-regexp");
const react_router_1 = require("react-router");
function matchURI(path, uri) {
  const keys = [];
  const pattern = toRegex(path, keys);
  const match = pattern.exec(uri);
  if (!match) return null;
  const params = Object.create(null);
  for (let i = 1; i < match.length; i++) {
    params[keys[i - 1].name] = match[i] !== undefined ? match[i] : undefined;
  }
  return params;
}
const routerEventPrefix = 'Router_';
const RouterMachineContext = React.createContext(undefined);
const MachineStateContext = React.createContext(undefined);
exports.MachineState = MachineStateContext.Consumer;
exports.RouterMachine = RouterMachineContext.Consumer;
exports.XStateRouter = react_router_1.withRouter((_a = class extends React.Component {
  constructor(props) {
    super(props);
    this.historyListener = location => {
      if (this.debounceHistory) {
        this.debounceHistory = false;
        return;
      }
      this.handleRouterTransition(location, true);
    };
    this.handleXStateTransition = state => {
      if (this.mounted) {
        this.setState({
          machineState: state
        });
      } else {
        this.machineState = state;
      }
      if (this.debounceState) {
        this.debounceState = false;
        return;
      }
      const stateNode = this.service.machine.getStateNodeByPath(state.tree.paths[0]);
      const path = findPathRecursive(stateNode);
      if (path) {
        this.debounceHistory = true;
        this.props.history.push(path);
      }
    };
    const config = this.props.config;
    const nodes = graph_1.getNodes(xstate_1.Machine(config));
    this.routes = [];
    for (const node of nodes) {
      if (node.meta && node.meta.path) {
        this.routes.push([node.path, node.meta.path]);
      }
    }
    // add router events to config
    if (!config.on) {
      config.on = {};
    }
    for (const route of this.routes) {
      config.on[routerEventPrefix + route[0].join('_')] = '#(machine).' + route[0].join('.');
    }
    // setup service
    const machine = xstate_1.Machine(config, this.props.options);
    this.machineState = machine.initialState;
    this.state = {
      machineState: this.machineState
    };
    this.service = interpreter_1.interpret(machine);
    this.service.start();
    this.service.onTransition(this.handleXStateTransition);
    // initial route
    this.handleRouterTransition(this.props.location);
    this.unlistenHistory = this.props.history.listen(this.historyListener);
  }
  handleRouterTransition(location, debounceHistory) {
    let matchingRoute;
    for (const route of this.routes) {
      const params = matchURI(route[1], location.pathname);
      if (params) {
        matchingRoute = route;
        break;
      }
    }
    if (matchingRoute) {
      this.debounceState = true;
      this.service.send(routerEventPrefix + matchingRoute[0].join('_'));
      const state = this.service.state.value;
      if (!utils_1.matchesState(state, matchingRoute[0].join('.'))) {
        const stateNode = this.service.machine.getStateNodeByPath(this.service.state.tree.paths[0]);
        if (stateNode.meta && stateNode.meta.path) {
          if (debounceHistory) {
            this.debounceHistory = true;
          }
          this.props.history.replace(stateNode.meta.path);
        }
      }
    }
  }
  componentDidMount() {
    this.mounted = true;
    this.setState({
      machineState: this.machineState
    });
  }
  componentWillUnmount() {
    this.service.off(this.handleRouterTransition);
    this.unlistenHistory();
  }
  render() {
    return React.createElement(RouterMachineContext.Provider, {
      value: this.service
    }, React.createElement(MachineStateContext.Provider, {
      value: this.state.machineState
    }, this.props.children));
  }
}, _a.propTypes = {
  config: PropTypes.object.isRequired,
  options: PropTypes.object
}, _a));
function findPathRecursive(stateNode) {
  let actual = stateNode;
  while (actual.parent) {
    if (actual.meta && actual.meta.path) {
      return actual.meta.path;
    }
    actual = actual.parent;
  }
}